module.exports = __webpack_public_path__ + "img/leap.04d0b560.svg";